import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Info } from "lucide-react";

const InvestorAgreementPolicy = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.breadcrumb}>Home &nbsp;›&nbsp; Investor Agreement Policy</div>

        <h1 style={styles.title}>Investor Agreement Policy</h1>
        <p style={styles.intro}>
          Formal investor agreement documentation for ClickNido will be published
          here once finalised.
        </p>

        <div style={styles.card}>
          <div style={styles.noteBar}>
            <Info size={16} color="#6d5efc" />
            <span>
              This page is a placeholder — the complete Investor Agreement Policy
              (terms, disclosures, and related documentation) is still being
              prepared and hasn't been published yet.
            </span>
          </div>
          <p style={styles.contactText}>
            If you're an investor or prospective investor with a query in the
            meantime, please get in touch directly.
          </p>
          <button style={styles.inlineLink} onClick={() => navigate("/contact-us")}>
            Contact Us <ArrowRight size={14} />
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    background: "#f5f6fb",
    minHeight: "100vh",
    padding: "40px 16px",
    fontFamily:
      "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    color: "#111827",
  },
  container: { maxWidth: "860px", margin: "0 auto" },
  breadcrumb: { color: "#7b8198", fontSize: "13px", fontWeight: 600, marginBottom: "14px" },
  title: { margin: 0, fontSize: "32px", fontWeight: 800, color: "#1c2148", marginBottom: "12px" },
  intro: { margin: "0 0 28px", fontSize: "15px", lineHeight: 1.75, color: "#5c6480", maxWidth: "700px" },
  card: {
    background: "#fff",
    borderRadius: "20px",
    padding: "26px",
    boxShadow: "0 1px 2px rgba(16,24,40,0.04), 0 8px 28px rgba(16,24,40,0.04)",
  },
  noteBar: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    background: "#f0eeff",
    borderRadius: "14px",
    padding: "16px 18px",
    fontSize: "13px",
    color: "#4a4470",
    lineHeight: 1.6,
    marginBottom: "18px",
  },
  contactText: { margin: "0 0 14px", fontSize: "14px", lineHeight: 1.8, color: "#5c6480" },
  inlineLink: {
    background: "transparent",
    border: "none",
    color: "#6d5efc",
    fontWeight: 700,
    fontSize: "14px",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    padding: 0,
  },
};

export default InvestorAgreementPolicy;
